export enum CoreType {
  STORAGE = "storage"
}
